import type { CanDeactivateFn } from '@angular/router';

// type-only: a value import would pull the lazy page into the main chunk
import type { AdminColumnMapping } from './admin-column-mapping';

export const columnMappingLeaveGuard: CanDeactivateFn<AdminColumnMapping> = (page) =>
  page.confirmLeave();
